module.exports = __webpack_public_path__ + "static/media/logo_icon.ecb573ca.png";